module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"review_policy":"レビュー運営方式"}}')
  delete Component.options._Ctor
}
